import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as DeleteIcon} from 'assets/svg/trash.svg';
import {ProductGroupIcon} from 'components/common/ProductGroupIcon';
import {Icon} from 'components/ui-kit/Icon';
import {IconButton} from 'components/ui-kit/IconButton';
import {ProductGroup} from 'core/constants/productGroups';

import {colors} from 'theme';

import {
    ProductSingleItemDescription,
    ProductSingleItemInfo,
    ProductSingleItemInfoName,
    ProductSingleItemRoot,
    ProductSingleItemText,
    ProductSingleItemType,
    ProductSingleItemControl,
} from '../styled';

export const ProductSingleItem = ({
    name,
    gtin,
    quantity,
    productGroupCode,
    onDelete,
}: {
    name: string;
    gtin: string;
    quantity: number;
    productGroupCode: ProductGroup;
    onDelete: () => void;
}) => {
    const {t} = useTranslation();
    return (
        <ProductSingleItemRoot>
            <ProductSingleItemType>
                <ProductGroupIcon
                    style={{marginBottom: 0}}
                    width={16}
                    value={productGroupCode as ProductGroup}
                />
            </ProductSingleItemType>
            <ProductSingleItemInfo>
                <ProductSingleItemInfoName>{name}</ProductSingleItemInfoName>
                <ProductSingleItemDescription>
                    <ProductSingleItemText>
                        {t('pages.orders.form.productCode', {gtin})}
                    </ProductSingleItemText>
                    <ProductSingleItemText>
                        {t('pages.orders.form.quantityItem', {quantity})}
                    </ProductSingleItemText>
                    <ProductSingleItemText>
                        {t('pages.orders.form.fromTypeItem', {
                            type: 'My Products',
                        })}
                    </ProductSingleItemText>
                </ProductSingleItemDescription>
            </ProductSingleItemInfo>
            <ProductSingleItemControl>
                <IconButton
                    onClick={() => {
                        onDelete();
                    }}
                    icon={
                        <Icon
                            source={DeleteIcon}
                            width={20}
                            height={20}
                            fillColor={colors.danger}
                        />
                    }
                />
            </ProductSingleItemControl>
        </ProductSingleItemRoot>
    );
};
